// If there's an accept button
if ( ofh_accept_button = document.querySelector( '#cookie-banner-js-accept-button' ) ) {

	// Add an event listener for when the button is clicked
  ofh_accept_button.addEventListener( 'click', function () {

		// Mixpanel tokens
		const mixpanel_token = ( window.location.hostname === 'ourfuturehealth.org.uk' ) ? 'd6e18580a026044ad38b69faafb499c9' : '3303c8160812904aa1ea20885c5f1118';

		// Check if we've got Mixpanel loaded
		// (not always the case due to privacy extensions and local testing)
		if ( typeof mixpanel !== 'undefined' ) {

			// Initialise Mixpanel
			mixpanel.init( mixpanel_token, { api_host: 'https://api-eu.mixpanel.com' } );

			// Track initial pageview
			mixpanel.track( 'Page Viewed', { 'page_url' : window.location.href, 'page_path': window.location.pathname, 'page_language': ofh_language_get( true ) } );

		}

		// If Mixpanel isn't defined, we need to set a placeholder cookie anyway
		// so the cookie notice doesn't show up again
		if ( typeof mixpanel === 'undefined' ) {

			// Write the placeholder accept cookie
			document.cookie =
				'mp_' + mixpanel_token + '_mixpanel=%7B%7D; ' +
				'max-age=31536000; ' + // Seconds in a year
				'path=/; ' +
				'domain=' + window.location.hostname + '; ' +
				'SameSite=Strict; ' +
				'Secure';

		}

		// Add any UTM parameters to the UTM cookie
		ofh_write_utm_cookie();

		// Remove the cookie banner from the DOM tree
		document.querySelector( '#cookie-banner-js' ).remove();
  } );

}

// If there's a decline button
if ( ofh_decline_button = document.querySelector( '#cookie-banner-js-decline-button' ) ) {

	// Add an event listener for when the button is clicked
  ofh_decline_button.addEventListener( 'click', function () {

		// Write the decline cookie
		document.cookie =
			'cookie_consent_refused=1; ' +
			'max-age=31536000; ' + // Seconds in a year
			'path=/; ' +
			'domain=' + window.location.hostname + '; ' +
			'SameSite=Strict; ' +
			'Secure';

		// Remove the cookie banner from the DOM tree
		document.querySelector( '#cookie-banner-js' ).remove();
  } );

}
